<h2>Representatives</h2>
<p-table #dt [value]="representatives" expandableRows="true" [globalFilterFields]="['name','email','cellPhone','effectiveDate','endDate','updatedDate','updatedBy']">
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="7">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Cell Phone</th>
            <th>Effective Date</th>
            <th>End Date</th>
            <th>Updated</th>
            <th>Updated By</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td class="td--hover-show">{{data.firstName}}&nbsp;{{data.lastName}}</td>
            <td class="td--hover-show">{{data.email}}</td>
            <td><span class="text-nowrap">{{data.cellPhone}}</span></td>
            <td>{{data.effectiveDate | shortDate}}</td>
            <td>{{data.endDate | shortDate}}</td>
            <td>{{data.updatedDate | dateTime}}</td>
            <td class="td--hover-show">{{data.updatedBy}}</td>
        </tr>
    </ng-template>
</p-table>
